import {Injectable} from '@angular/core';
import {AccountAdminService} from './api/account-admin.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AccountAdminDto} from '../dtos/accountAdmin.dto';
import {BrowserStorageService} from 'common';
import {AccountAdminOverviewDto} from '../dtos/accountAdminOverviewDto';

@Injectable({
    providedIn: 'root',
})
export class AccountsController {
    public static readonly PERSISTENCE_KEY = 'accounts';

    constructor(private _accountAdminService: AccountAdminService, private storage: BrowserStorageService) {
    }

    public getAll(): Observable<AccountAdminOverviewDto[]> {
        // Return cached, if already loaded
        if (this.storage.exists('accounts')) {
            return new Observable<AccountAdminOverviewDto[]>(observer => {
                const accounts = this.storage.loadDtos(AccountsController.PERSISTENCE_KEY, AccountAdminOverviewDto);
                observer.next(accounts);
                observer.complete();
            });
        }

        // load for the first time
        return this._accountAdminService.allAccounts()
            .pipe(map(accounts => {
                this.storage.saveDtos(AccountsController.PERSISTENCE_KEY, accounts);
                return accounts;
            }));
    }

    public getByEmailLikeQuery(emailValue: string): Observable<AccountAdminDto[]> {
        return this._accountAdminService.accountsByEmailLike(emailValue);
    }
}
